<h1>{{ heading }}</h1>
<ng-content></ng-content>
